import { useState, useEffect } from "react";
import { useDebounce } from '../hooks/useDebounce';
import { FaRegCalendar } from "react-icons/fa";
import { FaRegUser } from "react-icons/fa";
import { IoClose } from "react-icons/io5";
import { useQuery } from "@tanstack/react-query";
import { fetchAllUsers } from "../api/users";

export default function RecordListFilters({onChange}) {
        const [search, setSearch] = useState("");
        const debouncedSearch = useDebounce(search);
        const [worker, setWorker] = useState("");
        const [dateFrom, setDateFrom] = useState("");
        const [dateTo, setDateTo] = useState("");
        // const [users, setUsers] = useState([]);
        const [sheetOpen, setSheetOpen] = useState(false);

        const hasDateFilter = dateFrom || dateTo;

        useEffect(() => { 
            onChange({ search: debouncedSearch, worker, dateFrom, dateTo});
         }, [debouncedSearch, worker, dateFrom, dateTo, onChange]);

        const { data: users = []} = useQuery({
                queryKey: ['users'],
                queryFn: fetchAllUsers
        })
        // useEffect(() => {
        //         fetch(`http://192.168.40.160:8000/users/`)
        //         .then(res => res.json())
        //         .then(data => setUsers(data));
        // }, []);

        const clearDates = (e) => {
                e.stopPropagation();
                setDateFrom('');
                setDateTo('');
        };

        const dateLabel = () => {
                if (dateFrom && dateTo) return `${dateFrom} - ${dateTo}`;
                if (dateFrom) return `${dateFrom}`
                if (dateTo) return `${dateTo}`
                return "Date Range";
        }

        return (
        <>
                {/* Search */}
                <input 
                        type='text' 
                        value={search} onChange={(e) => setSearch(e.target.value)}
                        placeholder='Search records...'
                        className="w-full bg-primary-800 text-white px-4 py-3 rounded-xl border border-primary-50 focus:outline-none focus:border-secondary-800 
                        focus:ring-1 focus:ring-secondary-800 placeholder:text-primary-50 text-sm mb-3" />
                {/* Filter row */}
                <div className="flex gap-2 w-full mb-1">
                        {/* Worker Select */}
                        <div className="relative flex-1">
                                <FaRegUser className="absolute left-3 top-1/2 -translate-y-1/2 text-primary-10 text-xs pointer-events-none"/>
                                <select
                                        value={worker}
                                        onChange={(e) => setWorker(e.target.value)}
                                        className="w-full appearance-none bg-primary-800 border border-primary-50 text-primary-10 
                                        rounded-xl pl-8 pr-3 py-2.5 text-xs font-mono focus:outline-none focus:border-secondary-800 focus-ring-1 focus:ring-seondary-800">
                                        <option value="">All Workers</option>
                                        {users.map((u, i) => (
                                                <option value={u.telegram_id} key={i}>{u.name}</option>
                                        ))}
                                </select>
                        </div>
                        {/* Date Range */}
                        <button 
                                onClick={() => setSheetOpen(true)} 
                                className={`flex items-center gap-2 flex-1 rounded-xl px-3 py-2.5 text-xs font-mono border transition-colors 
                                ${hasDateFilter 
                                        ? 'bg-secondary-50 border-secondary-800 text-secondary-800'
                                        : 'bg-primary-800 border-primary-50 text-primary-10'
                                }`}>
                                <FaRegCalendar className="shrink-0"/>
                                <span className="truncate">{dateLabel()}</span>
                                {hasDateFilter && (
                                        <IoClose
                                        onClick={clearDates}
                                        className="shrink-0 ml-auto text-secondary-800 text-base"/>
                                )}
                        </button>
                </div>
                {/* Bottom Sheet */}
                {sheetOpen && (
                        <div className="fixed inset-0 z-50 bg-black/60" onClick={() => setSheetOpen(false)}>
                        <div className="absolute bottom-0 left-0 right-0 bg-[#13151f] rounded-t-2xl pt-3 pb-10"
                                onClick={e => e.stopPropagation()}>

                                {/* Drag handle */}
                                <div className="w-9 h-1 bg-[#2a2f4a] rounded-full mx-auto mb-5" />

                                <div className="px-5">
                                        <p className="text-white text-base font-semibold mb-1">Date Range</p>
                                        <p className="text-primary-50 text-xs font-mono mb-5">SELECT FROM · TO</p>
                                </div>

                                <div className="grid grid-cols-2 gap-2 mb-5 px-4 overflow-hidden">
                                        <div className="min-w-0">
                                                <label className="block text-xs text-primary-50 font-mono mb-1.5">FROM</label>
                                                <input type="date" value={dateFrom}
                                                onChange={e => setDateFrom(e.target.value)}
                                                style={{ width: '100%', maxWidth: '100%', boxSizing: 'border-box' }}
                                                className="block bg-[#0e0f14] text-white border border-[#1e2132] rounded-xl px-2 py-2.5 text-sm
                                                focus:outline-none focus:border-secondary-800"/>
                                        </div>
                                        <div className="min-w-0 pr-2">
                                                <label className="block text-xs text-primary-50 font-mono mb-1.5">TO</label>
                                                <input type="date" value={dateTo}
                                                onChange={e => setDateTo(e.target.value)}
                                                style={{ width: '100%', maxWidth: '100%', boxSizing: 'border-box' }}
                                                className="block bg-[#0e0f14] text-white border border-[#1e2132] rounded-xl px-2 py-2.5 text-sm
                                                focus:outline-none focus:border-secondary-800"/>
                                        </div>
                                </div>

                                <div className="flex gap-3 px-5">
                                        <button onClick={clearDates}
                                                className="flex-1 bg-[#1a1d2b] text-primary-50 rounded-xl py-3 text-xs font-mono">
                                                CLEAR
                                        </button>
                                        <button onClick={() => setSheetOpen(false)}
                                                className="flex-1 bg-secondary-800 text-white rounded-xl py-3 text-xs font-mono font-bold">
                                                APPLY RANGE
                                        </button>
                                </div>
                        </div>
                        </div>
                )}
        </>);
}